import React from 'react';
import { Container } from './style';
import {
   Box,
   Button,
   Card,
   // FormControl,
   IconButton,
   InputAdornment,
   InputLabel,
   TextField,
   // TextareaAutosize,
   Typography,
} from '@mui/material';
import * as Yup from 'yup';
import backImg from '../../../assets/back.svg';
import costImg from '../../../assets/cost.svg';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Formik } from 'formik';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
// import { messageSelector } from '../../../components/utils/selectors/selectors';
import { createSenderId } from '../../../components/app/features/message/messageSlice';
import { userLSAuth } from '../../../components/app/features/env';
import { useNavigate } from 'react-router-dom';
import SimpleModal from '../../../components/modal/SimpleModal'

export const FlatButton = styled(Button)(
   ({ theme }) => `
background: #0040BF;
color: #fff;
font-weight: 500;
width: 70%;
text-align: center;
font-size: 1rem;
border-radius:8px;
margin: 1rem auto;

&:hover {background: #0040bf;}

&.Mui-disabled {
  background: #0040bf;
  color: #fff;
  opacity: 0.6;
}
`
);

const TextInput = styled(TextField)(
   ({ theme }) => `
       background: #fff;
       color: #49454F;
       & .MuiOutlinedInput-root {
         background: #fff;
       }
       & .MuiOutlinedInput-root fieldset {
         border-color: #E5E5E5;
       }
       & .MuiOutlinedInput-root:hover fieldset {
         border-color: #E5E5E5;
       }
       & .MuiOutlinedInput-root.Mui-focused fieldset {
         border-color: #E5E5E5;
       }
     `
);

const VerifyId = () => {
   // const selector = useSelector(messageSelector);
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const [buttonText, setButtonText] = React.useState(false);

   return (
      <Container>
         <Card
            sx={{
               width: '90%',
               maxWidth: '615px',
               minHeight: '80vh',
               margin: '0 auto',
               marginTop: '2rem',
               position: 'relative',
               boxShadow:
                  '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
               padding: '25px ',
               background: 'white',
            }}
         >
            <Box
               sx={{
                  margin: '0 auto',
                 
                  border: '1px solid transparent',
                  position: 'relative',
               }}
            >
               <img
                  src={backImg}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '40px',
                     cursor: 'pointer',
                     marginTop:'0.5rem'
                  }}
                  onClick={() => window.history.back()}
               />
               <Typography
                     sx={{
                        textAlign: 'center',
                        fontSize:{ xs: '1.4rem', sm:'1.8rem',md:'2.3rem'} ,
                        fontWeight: '600',
                       
                       
                        color:'#2E2C21',
                     }}
                     className='font-cormorant'
               >
                  Sender ID Application
               </Typography>
               <Box sx={{ marginTop: '2rem' }}>
                  {/* <Typography
                     sx={{
                        fontWeight: 600,
                        fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                        alignContent: 'flex-start',
                        color: '#374DA0',
                        display: 'flex',
                        // border: '1px solid red',
                     }}
                  >
                     <img
                        src={costImg}
                        style={{
                           marginRight: '10px',
                           alignContent: 'flex-start',
                           // border: '1px solid red',
                           height: 'max-content',
                        }}
                        alt="icon"
                     />
                     Having an approved Sender ID guarantees that messages will
                     not fail to deliver due to violating industry regulations
                     on message sender identification.
                  </Typography> */}
                  <Typography
                     sx={{
                        fontWeight: 600,
                        color: '#374DA0',
                        fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                        alignContent: 'flex-start',
                        mt: 2,
                        display: 'flex',
                        justifyContent: 'center'
                     }}
                  >
                     <SimpleModal />
                  </Typography>
               </Box>
               <Formik
                  initialValues={{
                     senderId: '',
                     company: '',
                     usecase: '',
                     userId: userLSAuth().id,
                  }}
                  validationSchema={Yup.object().shape({
                     senderId: Yup.string()
                        .required('Please enter Sender ID')
                        .max(11, 'Sender ID must not be above 11 characters')
                        .matches(/^[a-zA-Z0-9]+$/, 'Sender ID can only contain letters and numbers'),
                     company: Yup.string().required(
                        'Please enter Company name'
                     ),
                     usecase: Yup.string()
                        .required('Field cannot be empty')
                        .min(10, 'Use case must be at least 10 characters'),
                  })}
                  onSubmit={async (values, { setSubmitting }) => {
                     dispatch(createSenderId(values));
                     setButtonText(true);
                     values.senderId = '';
                     values.company = '';
                     values.usecase = '';

                     setTimeout(() => {
                        setSubmitting(false);
                     }, 400);
                  }}
               >
                  {({
                     errors,
                     handleBlur,
                     handleChange,
                     handleSubmit,
                     isSubmitting,
                     touched,
                     values,
                     setFieldValue,
                  }) => (
                     <form
                        noValidate
                        onSubmit={handleSubmit}
                        style={{ marginTop: '2.2rem' }}
                     >
                        <InputLabel
                           htmlFor="senderId"
                           sx={{
                              fontWeight: 400,
                              color: '#2E2C21',
                              fontSize:{xs: '1rem', sm:'1.2rem', md:'1.4rem'} ,
                              lineHeight: 'unset',
                              mb: '10px',
                           }}
                        >
                           Sender ID
                        </InputLabel>
                        <TextInput
                           id="senderId"
                           // error={Boolean(touched.name && errors.name)}
                           fullWidth
                           margin="normal"
                           name="senderId"
                           placeholder="Enter Sender ID"
                           onBlur={handleBlur}
                           onChange={handleChange}
                           type="text"
                           value={values.senderId}
                           variant="outlined"
                           InputProps={{
                              endAdornment: (
                                 <InputAdornment position="end">
                                    <IconButton
                                       edge="end"
                                       onClick={() => {
                                          setFieldValue('senderId', '');
                                       }}
                                    >
                                       <HighlightOffIcon />
                                    </IconButton>
                                 </InputAdornment>
                              ),
                           }}
                        />
                        <span style={{ color: 'red' }}>
                           {errors.senderId &&
                              touched.senderId &&
                              errors.senderId}
                        </span>
                        <InputLabel
                           htmlFor="companyName"
                           sx={{
                              fontWeight: 400,
                              color: '#2E2C21',
                              fontSize:{xs: '1rem', sm:'1.2rem', md:'1.4rem'} ,
                              lineHeight: 'unset',
                              mt: 2,
                              mb: '10px',
                           }}
                        >
                           Business Name
                        </InputLabel>
                        <TextInput
                           fullWidth
                           id="companyName"
                           margin="normal"
                           name="company"
                           placeholder="Enter Business Name"
                           error={Boolean(touched.company && errors.company)}
                           onBlur={handleBlur}
                           onChange={handleChange}
                           type="text"
                           value={values.company}
                           variant="outlined"
                           InputProps={{
                              // startAdornment: (
                              // 	<InputAdornment position='start'>
                              // 		<img src={phoneImg} alt='phone' />
                              // 	</InputAdornment>
                              // ),
                              endAdornment: (
                                 <InputAdornment position="end">
                                    <IconButton
                                       edge="end"
                                       onClick={() => {
                                          setFieldValue('company', '');
                                       }}
                                    >
                                       <HighlightOffIcon />
                                    </IconButton>
                                 </InputAdornment>
                              ),
                           }}
                        />
                        <span style={{ color: 'red' }}>
                           {errors.company && touched.company && errors.company}
                        </span>
                        <InputLabel
                           htmlFor="sampleMsg"
                           sx={{
                              fontWeight: 400,
                              color: '#2E2C21',
                              fontSize:{xs: '1rem', sm:'1.2rem', md:'1.4rem'} ,
                              lineHeight: 'unset',
                              mt: 2,
                              mb: '10px',
                           }}
                        >
                           Sample Message
                        </InputLabel>
                        <textarea
                           name="usecase"
                           value={values.usecase}
                           onChange={handleChange}
                           placeholder="Enter in a sample of the type of information/messages you will send using this Sender ID.   Example: New goods are available"
                           style={{
                              width: '100%',
                              display: 'block',
                              minHeight: '150px',
                              borderColor: '#E5E5E5',
                              borderRadius: '6px',
                              background: '#fff',
                              fontSize: '1rem',
                              padding: '10px',
                           }}
                           id="sampleMsg"
                           className="focus"
                        ></textarea>
                        <span style={{ color: 'red' }}>
                           {errors.usecase && touched.usecase && errors.usecase}
                        </span>
                        <Box display={'flex'} sx={{ marginTop: '2rem' }}>
                           <FlatButton
                              disabled={
                                 !values.senderId ||
                                 !values.company ||
                                 !values.usecase ||
                                 Boolean(errors.senderId && touched.senderId)
                              }
                              type="submit"
                           >
                              Apply
                           </FlatButton>
                        </Box>
                     </form>
                  )}
               </Formik>
               {buttonText === true && (
                  <Typography
                     sx={{
                        fontWeight: 600,
                        fontSize: '0.9rem',
                        color: '#374DA0',
                        fontFamily: "'Raleway', 'Montserrat', sans-serif",
                        mb: 2,
                        display: 'flex',
                        justifyContent: 'center',
                     }}
                  >
                     <img
                        src={costImg}
                        style={{ marginRight: '10px' }}
                        alt="icon"
                     />
                     This verification process can take about 48-72hrs to
                     complete.
                  </Typography>
               )}
               {!buttonText && (
                  <Box
                     sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '0.5rem',
                     }}
                  >
                     <Button
                        sx={{
                           width: '70%',
                           fontSize: '1rem',
                           padding: '7px 0',
                           borderRadius: '6px',
                           fontWeight: 600,
                           border: '1px solid #0040BF',
                           color: '#0040BF',
                           background: 'transparent',
                           '&:hover': { background: 'transparent', borderColor: '#0040BF' }
                        }}
                        variant="outlined"
                        onClick={() => navigate('/send-message/idHistory')}
                     >
                        View Sender ID History
                     </Button>
                  </Box>
               )}
            </Box>
         </Card>
      </Container>
   );
};

export default VerifyId;
